import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MDialog, { ACTION_CLOSE } from "components/Shared/MDialog.tsx";
import { MSpinner } from "components/Shared";
import { moveToScheduling } from "requests/schedulingAssistant";
import responseHandler from "responseHandler";
import Button from "@mui/material/Button";

interface MoveToSchedulingProps {
  insuranceCases: Int32Array[];
  visible: boolean;
  makeToast:  (arg1, arg2) => void;
  hideDialog: () => void;
}

const MoveToScheduling = (props : MoveToSchedulingProps) => {
  const [sendingReq, setSendingReq] = useState<boolean>(false);
  const mounted = useRef(true);
  useEffect(() => {
    return (() => { mounted.current = false; });
  }, []);

  const hasInsuranceCases = props.insuranceCases?.length > 0;

  let dialogText;
  if (props.insuranceCases === null || sendingReq) {
    dialogText = <MSpinner />;
  } else if (hasInsuranceCases) {
    dialogText = "Are you sure you would like to move these cases to scheduling?";
  } else {
    dialogText = "There are no cases selected for scheduling.";
  }

  const moveToSchedulingRequest = () => {
    setSendingReq(true);
    moveToScheduling({
      ControlNumbers: props.insuranceCases
    }, () => {
      props.makeToast("Cases moved to Scheduling, please refresh the QuickList.", "success");
      setSendingReq(false);
      props.hideDialog();      
    }, () => {
      setSendingReq(false);
      props.hideDialog();
    }, mounted);
  };

  return (
    <MDialog
      id="move-to-scheduling-dialog"
      title="Move to Scheduling"
      actions={[{ code: ACTION_CLOSE, onClick: props.hideDialog }]}
      contentActions={[
        <Button key="moveToSchedulingKey" disabled={!hasInsuranceCases} onClick={() => moveToSchedulingRequest()} >Move to Scheduling</Button>
      ]}
      visible={props.visible}
    >
      <p>{dialogText}</p>
    </MDialog>
  );
};

const mapDispatchToProps = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
});

export default connect(null, mapDispatchToProps)(MoveToScheduling);